import { MagicWandIcon } from '@carboncopyco/icons';
import {
  Button,
  ColorHex,
  Loading,
  TextBoxEditorTitle,
  notify,
} from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import { useState } from 'react';
import { EditToolDialog } from '../EditToolDialog';
import { Prompt } from './Prompt';
import { PromptExamples } from './PromptExamples';

type AIResponse = {
  message: string;
  modified: unknown[];
  code: string;
  raw_response: string;
  success: boolean;
};

type EditWithAIProps = {
  onClose: () => void;
  onResponse: (response: AIResponse['modified']) => void;
  dataToModify: unknown[];
  dataKey: string;
};

const url =
  'https://data-rule-code-builder-v3jfug5qxq-uc.a.run.app/replace_column';

export const EditWithAIDeprecated = ({
  onResponse,
  onClose,
  dataToModify,
  dataKey,
}: EditWithAIProps) => {
  const [isLoading, setIsLoading] = useBoolean(false);
  const [promptValue, setPromptValue] = useState('');

  const onSubmit = async () => {
    if (isLoading) return;

    setIsLoading.setTrue();
    try {
      const response = await fetch(url, {
        headers: {
          'content-type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          column_data: dataToModify,
          column_name: dataKey,
          prompt: promptValue,
        }),
      });
      const { modified } = (await response.json()) as AIResponse;
      onResponse(modified);
      onClose();
    } catch (_error) {
      notify.error('Failed to generate, please try again.');
    } finally {
      setIsLoading.setFalse();
    }
  };

  return (
    <EditToolDialog
      draggable={false}
      onClose={onClose}
      title={
        <div className="flex gap-1.5">
          <MagicWandIcon
            size={16}
            color={ColorHex.primary300}
          />
          <TextBoxEditorTitle
            label="Edit WITH AI"
            uppercase
            fontWeight="font-ds-medium"
            color="text-ds-natural-600"
          />
        </div>
      }
    >
      <div className="flex flex-col w-[397px] border-t border-ds-natural-150 px-4 pb-4 pt-5">
        <Prompt
          onChange={setPromptValue}
          value={promptValue}
        />
        <PromptExamples />
        <div className="flex justify-between items-center pt-5">
          <Button
            label="Cancel"
            onClick={onClose}
            link
          />
          <Button
            style={{ width: 77 }}
            disabled={!promptValue}
            aria-label="Submit"
            label={!isLoading ? 'Apply' : ''}
            onClick={onSubmit}
            icon={
              isLoading ? <Loading color="text-ds-accent3-100" /> : undefined
            }
          />
        </div>
      </div>
    </EditToolDialog>
  );
};
